import * as React from 'react';
import { Text } from '@audi/audi-ui-react-v2';
export const DealerChain = ({ dealers, dealersHeadline }) => {
    return (React.createElement("div", { className: "dealer-chain" }, dealers ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { as: "h2", variant: "order2", spaceStackEnd: "l" }, dealersHeadline),
        dealers.map((dealer) => (React.createElement(Text, { spaceStackEnd: "s", key: dealer.id }, dealer.name))))) : null));
};
